//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Builder.js";
import "../no/ugmath.js";
let d=[[[0,"MirrorCsysMethod",1,0],[0,"MirrorPartName",1,0],[0,"MirrorPartType",1,0],[0,"MirrorPlane",1,"Plane",0],[0,"MirrorPlaneNormal",1,0],[0,"MirrorPlaneOrigin",1,0],[0,"MirrorPmiFlag",1,0],[0,"NewPart",1,"Part",0],[0,"ParentPart",1,"Part",0]],[[["nRefSetNames"],"GetRefSetNames",{R_:{refSetNames:""}},0,0],[["refSetNames"],"SetRefSetNames",{},1,0]],[]];
SPLM.LinkedMirrorPartBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.LinkedMirrorPartBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.LinkedMirrorPartBuilder.MirrorCsysOption = Object.freeze({
    "MirrorXYAndDeriveZ" : "MirrorXYAndDeriveZ", "MirrorYZAndDeriveX" : "MirrorYZAndDeriveX", "MirrorXZAndDeriveY" : "MirrorXZAndDeriveY"});

SPLM.LinkedMirrorPartBuilder.MirrorPartTypeOption = Object.freeze({
    "ExactMirror" : "ExactMirror", "NonExactMirrorKeepBrokenLinks" : "NonExactMirrorKeepBrokenLinks", "NonExactMirrorDeleteBrokenLinks" : "NonExactMirrorDeleteBrokenLinks"});

export default SPLM;